import { render, staticRenderFns } from "./UserBugDetails.vue?vue&type=template&id=647e8219&scoped=true&"
import script from "./UserBugDetails.vue?vue&type=script&lang=js&"
export * from "./UserBugDetails.vue?vue&type=script&lang=js&"
import style0 from "./UserBugDetails.vue?vue&type=style&index=0&id=647e8219&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "647e8219",
  null
  
)

export default component.exports